import { createSelector } from 'reselect'
import InternalSidebar, { InternalSidebarDispatchProps, InternalSidebarStateProps, InternalSidebarOwnProps } from 'components/features/pfm/InternalSidebar/InternalSidebar'
import { setShownSidebarPaneActionCreator } from 'actions/sidebarActions'
import { connect } from 'react-redux'
import { isShrunkSidebarSelector, shownSidebarPaneSelector, createOwnPropsSelector, currentPageSelector } from 'selectors/globalSelectors'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { viewportSegmentSelector } from 'selectors/viewportSelectors'
import { previousUrlSelector, previousUrlsSelector } from 'selectors/navigationSelectors'
import { URL_PAGE_MAP } from 'constants/pages'

type InternalSidebarContainerInnerOwnProps = RouteComponentProps<{}> & InternalSidebarOwnProps

const mapStateToProps = createSelector(
  shownSidebarPaneSelector,
  previousUrlSelector,
  previousUrlsSelector,
  isShrunkSidebarSelector,
  viewportSegmentSelector,
  currentPageSelector,
  createOwnPropsSelector<InternalSidebarContainerInnerOwnProps>(),
  (shownPane, previousUrl, previousUrls, isShrunkSidebar, viewportSegment, currentPage, ownProps): InternalSidebarStateProps => ({
    shownPane,
    viewportSegment,
    previousUrl,
    currentPage,
    historyLength: previousUrls.length,
    goBack: () => ownProps.history.goBack(),
    backPage: ownProps.backPage === undefined ? URL_PAGE_MAP[previousUrl] : ownProps.backPage,
    mode: isShrunkSidebar ? 'navigation' : 'common',
  })
)

const mapDispatchToProps: InternalSidebarDispatchProps = {
  setShownSidebarPane: setShownSidebarPaneActionCreator,
}

const InternalSidebarContainerInner = connect<
  InternalSidebarStateProps, InternalSidebarDispatchProps, InternalSidebarContainerInnerOwnProps
>(mapStateToProps, mapDispatchToProps)(InternalSidebar)

const InternalSidebarContainer = withRouter(InternalSidebarContainerInner)

export default InternalSidebarContainer
